import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_CONTACT_US_ARTS(state,data) {
        state.contactUsArts = data;
        //setStore('moduleName','Key',value)
        setStore('website','contactUs,contactUsArts,list',data)
    },
    SET_CURRENT_CONTACT_US_ART(state,data) {
        state.currentContactUsArt = data;
        //setStore('moduleName','Key',value)
        setStore('website','contactUs,contactUsArts,currentContactUsArt',data)
    },
    SET_CONTACT_US_FIELDS(state,data) {
        state.contactUsFields = data;
        //setStore('moduleName','Key',value)
        setStore('website','contactUs,contactUsFields,list',data)
    },
    SET_CURRENT_CONTACT_US_FIELD(state,data) {
        state.currentContactUsField = data;
        //setStore('moduleName','Key',value)
        setStore('website','contactUs,contactUsFields,currentContactUsField',data)
    },
    
};
